import { Action } from './Action';
import { CLEAR_ALL } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */

class ClearAllAction extends Action {

  static get name() { return 'ClearAllAction'; }

  _executeImpl() {
    const self = this;

    return this.component.$apollo.mutate({
      mutation: CLEAR_ALL,
      variables: {
        id: this.component.shoppingList.id,
      },
      update(store, { data: { shoppingListClearAll } }) {
        self._updateCache(store, shoppingListClearAll);
      },
      optimisticResponse: {
        shoppingListClearAll: {
          __typename: 'ShoppingListClearAllResult',
          id: self.component.shoppingList.id,
          modifiedAt: null,
        },
      },
    });
  }

  /* eslint-disable class-methods-use-this */
  updateQuery(cachedShoppingList) {
    cachedShoppingList.items.checked = [];
    cachedShoppingList.items.unchecked = [];

    return cachedShoppingList;
  }
}

export default ClearAllAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/ClearAllAction.js